import script from "./AppNotificationIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNotificationIcon.vue?vue&type=script&setup=true&lang=ts"

import "./AppNotificationIcon.vue?vue&type=style&index=0&id=290ef583&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-290ef583"]])

export default __exports__